var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexBox"},[_c('div',{staticClass:"labSection"},[_c('iframe',{attrs:{"src":_vm.labUrl,"frameborder":"0","scrolling":"auto"}})]),_c('business'),(!_vm.isMobile)?_c('media'):_vm._e(),(_vm.isMobile)?_c('media-wx'):_vm._e(),_c('nationalMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }